export default __webpack_public_path__ + "static/media/rocket_anim_76.ecc1b15a.png";